import React, { useState, useRef, forwardRef, useEffect } from "react";
import { Mlogo } from "../assets/index";
import { useNavigate } from "react-router-dom";

// ✅ Currency formatter
const formatCurrency = (num) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
  }).format(num || 0);

// ✅ Invoice Content
const InvoiceContent = forwardRef(
  (
    {
      invoiceNo,
      billTo,
      setBillTo,
      items,
      handleItemChange,
      addRow,
      subtotal,
      gst,
      transport,
      setTransport,
      grandTotal,
      signatory,
      setSignatory,
      setInvoiceDate,
      setInvoiceNo,
      invoiceDate,
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className="bg-white w-full max-w-[850px] border shadow-lg p-4 sm:p-6 md:p-8 rounded-lg print:shadow-none print:border-none print:rounded-none font-sans overflow-x-auto"
      >
        {/* Header */}
        <div className=" md:items-center border-b-2 border-gray-700 pb-4 mb-4 space-y-4 md:space-y-0">
          <div className=" space-x-3 flex  md:flex-row justify-between items-start">
            <img src={Mlogo} alt="Logo" className="h-12" />
            <div>
              <h1 className="text-xl font-bold uppercase tracking-wide">
                Proforma Invoice
              </h1>
              <p className="text-sm text-gray-600">
                Marker Electronic Equipments
              </p>
            </div>
          </div>
        </div>

        {/* Company + Bill To */}
        <div className="flex flex-col sm:flex-row justify-between gap-4 border-b border-gray-400 pb-4 mb-4 text-sm">
          <div className="sm:w-1/2 w-full">
            <p className="font-bold text-gray-800">From:</p>
            <p>MARKER ELECTRONIC EQUIPMENTS</p>
            <p>Plot no 91/1(D), Satpur MIDC, Nashik 422007. (India)</p>
            <p>+91 755 933 6283</p>
            <p>GST NO : 27ABMPB9440N2ZN</p>
          </div>
          <div className="text-right text-sm">
            <div className="flex flex-col space-y-2">
              <div>
                <span className="font-bold">Invoice No: </span>
                <input
                  type="text"
                  value={invoiceNo}
                  onChange={(e) => setInvoiceNo(e.target.value)}
                  className="border border-gray-400 p-1 rounded text-sm w-32 focus:ring-1 focus:ring-blue-500 print:border-none print:outline-none"
                />
              </div>
              <div>
                <span className="font-bold">Date: </span>
                <input
                  type="date"
                  value={invoiceDate}
                  onChange={(e) => setInvoiceDate(e.target.value)}
                  className="border border-gray-400 p-1 rounded text-sm w-36 focus:ring-1 focus:ring-blue-500 print:border-none print:outline-none"
                />
              </div>
            </div>
          </div>
        </div>
        <div className=" text-right sm:text-right justify-end">
          <p className="font-bold text-gray-800">Bill To:</p>
          <textarea
            value={billTo}
            onChange={(e) => setBillTo(e.target.value)}
            placeholder="Enter customer details..."
            className="w-64 h-20 border border-gray-400 text-sm p-2 rounded focus:ring-1 focus:ring-blue-500 print:border-none print:outline-none"
          />
        </div>
        {/* Table */}
        <div className="overflow-x-auto rounded-lg border border-gray-300">
          <table className="w-full border border-gray-400 text-sm">
            <thead className="bg-gray-100 text-gray-800">
              <tr>
                <th className="border border-gray-400 p-2 w-12">Sr no</th>
                <th className="border border-gray-400 p-2 text-center">
                  Particular
                </th>
                <th className="border border-gray-400 p-2 w-20 text-center">
                  Qty
                </th>
                <th className="border border-gray-400 p-2 w-24 text-center">
                  Rate
                </th>
                <th className="border border-gray-400 p-2 w-24 text-center">
                  Discount (%)
                </th>
                <th className="border border-gray-400 p-2 w-28 text-center">
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, i) => (
                <tr key={i} className="odd:bg-white even:bg-gray-50">
                  <td className="border border-gray-300 text-center p-2">
                    {i + 1}
                  </td>
                  <td className="border border-gray-300 p-1 text-center">
                    <input
                      type="text"
                      value={item.particular}
                      onChange={(e) =>
                        handleItemChange(i, "particular", e.target.value)
                      }
                      className="w-full border p-1 text-sm rounded focus:ring-1 focus:ring-blue-500 print:border-none"
                    />
                  </td>
                  <td className="border border-gray-300 p-1 text-right">
                    <input
                      type="number"
                      value={item.qty}
                      onChange={(e) =>
                        handleItemChange(i, "qty", e.target.value)
                      }
                      className="w-full border p-1 text-sm text-center rounded focus:ring-1 focus:ring-blue-500 print:border-none"
                    />
                  </td>
                  <td className="border border-gray-300 p-1 text-center">
                    <input
                      type="number"
                      value={item.rate}
                      onChange={(e) =>
                        handleItemChange(i, "rate", e.target.value)
                      }
                      className="w-full border p-1 text-sm text-center rounded focus:ring-1 focus:ring-blue-500 print:border-none"
                    />
                  </td>
                  <td className="border border-gray-300 p-1 text-center">
                    <input
                      type="text"
                      value={item.per}
                      onChange={(e) =>
                        handleItemChange(i, "per", e.target.value)
                      }
                      className="w-full border p-1 text-sm rounded focus:ring-1 focus:ring-blue-500 print:border-none"
                    />
                  </td>
                  <td className="border border-gray-300 text-center pr-2">
                    {formatCurrency(item.amount)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Add Row */}
        <div className="px-2 py-3">
          <button
            type="button"
            onClick={addRow}
            className="mt-2 px-4 py-1 bg-blue-600 hover:bg-blue-700 text-white rounded text-sm shadow print:hidden"
          >
            + Add Row
          </button>
        </div>

        {/* Totals */}
        <div className="flex justify-end mt-4 w-full sm:w-auto">
          <div className="border border-gray-400 w-full sm:w-80 rounded text-sm">
            <div className="flex justify-between px-3 py-2 border-b border-gray-300">
              <span>Subtotal</span>
              <span>{formatCurrency(subtotal)}</span>
            </div>
            <div className="flex justify-between px-3 py-2 border-b border-gray-300">
              <span>GST @18%</span>
              <span>{formatCurrency(gst)}</span>
            </div>
            <div className="flex justify-between px-3 py-2 border-b border-gray-300">
              <span>Transport</span>
              <input
                type="number"
                value={transport}
                onChange={(e) => setTransport(e.target.value)}
                className="w-20 text-right border px-1 rounded focus:ring-1 focus:ring-blue-500 print:border-none"
              />
            </div>
            <div className="flex justify-between px-3 py-2 font-bold bg-gray-100">
              <span>Grand Total</span>
              <span>{formatCurrency(grandTotal)}</span>
            </div>
          </div>
        </div>

        {/* Terms */}
        <div className="mt-6 text-sm">
          <p className="font-bold underline text-gray-800 mb-2">
            TERMS & CONDITIONS
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            <li>Payment : 100% Advance</li>
            <li>Transport : -</li>
            <li>Delivery Period : -</li>
          </ul>
        </div>

        {/* Bank Details */}
        <div className="mt-6 text-sm">
          <p className="font-bold underline text-gray-800 mb-2">
            OUR BANK DETAILS
          </p>
          <p>ICICI BANK LTD,</p>
          <p>MARTIN NAGAR, NASHIK - 422005,</p>
          <p>Current Account No : 10880500271</p>
          <p>IFSC Code : ICIC0001085</p>
        </div>
      </div>
    );
  }
);

export default function InvoicePage() {
  const navigate = useNavigate();
  const [billTo, setBillTo] = useState("");
  const [items, setItems] = useState([
    { particular: "", qty: "", rate: "", per: "", amount: 0 },
  ]);
  const [transport, setTransport] = useState(0);
  const [invoiceNo, setInvoiceNo] = useState(
    `INV-${Date.now().toString().slice(-6)}`
  );
  const [invoiceDate, setInvoiceDate] = useState(
    new Date().toISOString().split("T")[0]
  ); // YYYY-MM-DD

  const [signatory, setSignatory] = useState("");
  const GST_RATE = 0.18;
  const componentRef = useRef();
  const [showDownloadOptions, setShowDownloadOptions] = useState(false);

  const handlePreview = (format) => {
    navigate("/PreviewPage", {
      state: {
        format, // pdf / word / excel
        invoiceData: {
          invoiceNo,
          invoiceDate,
          billTo,
          items,
          subtotal,
          gst,
          transport,
          grandTotal,
          signatory,
        },
      },
    });
  };

  const handleItemChange = (index, field, value) => {
    const newItems = [...items];
    newItems[index][field] = value;

    const qty = parseFloat(newItems[index].qty) || 0;
    const rate = parseFloat(newItems[index].rate) || 0;
    const discountPercent = parseFloat(newItems[index].per) || 0;

    let amount = qty * rate;

    // ✅ Apply discount if entered
    if (discountPercent > 0) {
      amount = amount - (amount * discountPercent) / 100;
    }

    newItems[index].amount = amount;

    setItems(newItems);
  };

  const addRow = () => {
    setItems([
      ...items,
      { particular: "", qty: "", rate: "", per: "", amount: 0 },
    ]);
  };

  const subtotal = items.reduce(
    (sum, item) => sum + (parseFloat(item.amount) || 0),
    0
  );

  const gst = subtotal * GST_RATE;
  const grandTotal = subtotal + gst + parseFloat(transport || 0);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest("#downloadMenu")) {
        setShowDownloadOptions(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center py-6">
      <div id="downloadMenu" className="mb-4 relative print:hidden">
        <button
          type="button"
          onClick={() => setShowDownloadOptions(!showDownloadOptions)}
          className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded shadow"
        >
          Download
        </button>

        {showDownloadOptions && (
          <div className="absolute mt-2 bg-white border rounded-lg shadow-lg p-2 flex flex-col space-y-2 w-40 right-0 z-50">
            <button
              onClick={() => handlePreview("pdf")}
              className="px-3 py-1 text-sm text-red-400 hover:text-red-600 cursor-pointer rounded"
            >
              PDF (jsPDF)
            </button>
            <button
              onClick={() => handlePreview("word")}
              className="px-3 py-1 text-sm text-indigo-400 cursor-pointer hover:bg-indigo-600 rounded"
            >
              Word
            </button>
            <button
              onClick={() => handlePreview("excel")}
              className="px-3 py-1 text-sm text-yellow-400 hover:text-yellow-600 rounded"
            >
              Excel
            </button>
          </div>
        )}
      </div>

      <InvoiceContent
        ref={componentRef}
        invoiceNo={invoiceNo}
        setInvoiceNo={setInvoiceNo}
        invoiceDate={invoiceDate}
        setInvoiceDate={setInvoiceDate}
        billTo={billTo}
        setBillTo={setBillTo}
        items={items}
        handleItemChange={handleItemChange}
        addRow={addRow}
        subtotal={subtotal}
        gst={gst}
        transport={transport}
        setTransport={setTransport}
        grandTotal={grandTotal}
        signatory={signatory}
        setSignatory={setSignatory}
      />
    </div>
  );
}
